import axios from "../../../utils/axios";

/**
 * What remains of the old registration API after the password flow was
 * removed. The two `/identity-verifications/` calls below still back the
 * delete-account OTP; they have no counterpart on the Sayagie backend and go
 * when that screen moves to the two-step deactivation flow.
 */

export const identificationTraceId = (phoneNumber) => {
  const formData = {
    phone: phoneNumber,
  };

  return axios
    .post(`/identity-verifications/phone`, formData)
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((error) => console.log("error", error));
};

export const IdentityVerficationOtpTraceId = (traceId, otpCode, cb) => {
  return axios
    .get(`/identity-verifications/${traceId}/verify-otp/${otpCode}`)
    .then((response) => {
      const { data } = response;
      cb(null, data);
    })
    .catch((error) => {
      const { response } = error;
      const { data } = response;
      cb(data);
    });
};

export const fetchOperations = async () => {
  return await axios.get("/operations/");
};

export const refreshAuth = async (refreshToken) => {
  return await axios.post("/login/refresh/", { refreshToken }, {}, true);
};

